import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PageErrorComponent} from "./pageError/page-error.component";
import {NotAuthorizedComponent} from "./notAuthorized/not-authorized.component";
import {NotFoundComponent} from "./notFound/not-found.component";
import {TimeoutComponent} from "src/app/modules/error/timeOut/timeout.component";
import {BadRequestComponent} from "src/app/modules/error/badRequest/bad-request.component";


const routes: Routes = [
    {path: 'error', component: PageErrorComponent, data: {title: 'Erreur'}},
    {path: '400', component: BadRequestComponent, data: {title: '400'}},
    {path: '403', component: NotAuthorizedComponent, data: {title: '403'}},
    {path: '404', component: NotFoundComponent, data: {title: '403'}},
    {path: '412', component: TimeoutComponent, data: {title: '412'}},
    {path: '**', redirectTo: 'error'}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ErrorRoutingModule {
}
